import {
  ACTIVO_REFERIDOS,
  CLEAR_ALL,
  GETALL_REFERIDOS,
  LOADING_GETALL_REFERIDOS,
  PARAMS_REFERIDOS,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const referidosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_REFERIDOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_REFERIDOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_REFERIDOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_REFERIDOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
